import React, {Component} from 'react';
import {Redirect, Route} from 'react-router-dom';
import {connect} from "react-redux";

import urls from '../../../values/urls';

import {setNextLink} from "./actions";

class LoggedInRoute extends Component {
    constructor(props) {
        super(props);

        // console.log('redirect constructor');
        // console.log(window.location.toString());
        this.setNext();
    }

    setNext() {
        const {user} = this.props;

        if (!user.isAuthenticated) {
            const url = window.location.pathname + window.location.search;
            this.props.setNextLink(url);
        }
    }

    render() {
        // console.log('redirect rendering');
        const {component: Component, exact, user, skipPasswordCheck, ...rest} = this.props;

        return (
            <Route exact={exact} {...rest} render={(props) => {
                if (!user.isAuthenticated) {
                    return <Redirect to={urls.LOGIN}/>;
                }

                // force the user to set a new password before using the app
                if (!skipPasswordCheck && user.user && user.user.must_change_password) {
                    return <Redirect to={urls.CHANGE_PASSWORD}/>;
                }

                return <Component {...props} />;
            }}/>
        );
    }
}

function mapStateToProps({user}) {
    return {user};
}

export default connect(mapStateToProps, {setNextLink})(LoggedInRoute);